if (!customElements.get('eight-rox-home')) {
class EightRoxHome extends HTMLElement {
  connectedCallback() {
    this.cartCount = this.querySelector('[data-cart-count]');
    this.refreshCartCount();
    this.bindHero();
    this.bindQuickAdd();
    bindMobileMenus();
    this.bindBundle();
    this.bindRecentlyViewed();
  }

  bindHero() {
    const slides = [...this.querySelectorAll('[data-hero-slide]')];
    if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let active = 0;
    const show = (next) => {
      slides[active].classList.remove('is-active');
      active = (next + slides.length) % slides.length;
      slides[active].classList.add('is-active');
    };
    this.querySelector('[data-hero-prev]')?.addEventListener('click', () => show(active - 1));
    this.querySelector('[data-hero-next]')?.addEventListener('click', () => show(active + 1));
    window.setInterval(() => show(active + 1), 3000);
  }

  bindQuickAdd() {
    this.querySelectorAll('[data-quick-add]').forEach((button) => {
      bindQuickAddButton(button);
    });
  }

  bindBundle() {
    this.querySelectorAll('[data-look-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const look = tab.dataset.lookTab;
        this.querySelectorAll('[data-look-tab]').forEach((el) => el.setAttribute('aria-pressed', String(el === tab)));
        this.querySelectorAll('[data-look-panel]').forEach((panel) => panel.hidden = panel.dataset.lookPanel !== look);
      });
    });

    this.querySelectorAll('[data-look-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const selects = [...form.querySelectorAll('select[data-variant-select]')];
        const missing = selects.find((select) => !select.value);
        form.querySelector('[data-look-warning]')?.toggleAttribute('hidden', !missing);
        selects.forEach((select) => select.setAttribute('aria-invalid', String(!select.value)));
        if (missing) {
          missing.focus();
          return;
        }
        const items = selects.map((select) => ({ id: Number(select.value), quantity: 1 })).filter((item) => item.id);
        if (items.length) await this.addItems(items);
      });
    });
  }

  bindRecentlyViewed() {
    const section = this.querySelector('[data-recently-viewed-section]');
    const target = this.querySelector('[data-recent-products]');
    const empty = this.querySelector('[data-recent-empty]');
    const data = this.querySelector('[data-recent-json]');
    if (!target || !empty || !data) { if (section) section.hidden = true; return; }
    let products = [];
    try { products = JSON.parse(data.textContent || '[]'); } catch { products = []; }
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('8rox-clothing-recently-viewed') || '[]'); } catch { handles = []; }
    const byHandle = new Map(products.map((product) => [product.handle, product]));
    const viewed = handles.map((handle) => byHandle.get(handle)).filter(Boolean).slice(0, 8);
    if (!viewed.length) { if (section) section.hidden = true; return; }
    if (section) section.hidden = false;
    empty.hidden = true;
    target.hidden = false;
    target.innerHTML = viewed.map((product) => `
      <a href="${product.url}">
        <img src="${product.image}" alt="" loading="lazy">
        <div><h3>${product.title}</h3><p>${product.price}</p></div>
      </a>
    `).join('');
  }

  async addItems(items) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    await this.refreshCartCount();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  async refreshCartCount() {
    if (!this.cartCount) return;
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    updateCartLabels(cart.item_count || 0);
  }
}

customElements.define('eight-rox-home', EightRoxHome);
}

async function bindQuickAddButton(button) {
  if (button.dataset.quickAddBound === 'true') return;
  button.dataset.quickAddBound = 'true';
  const originalMarkup = button.innerHTML;
  button.addEventListener('click', async (event) => {
    event.preventDefault();
    if (button.disabled || button.dataset.quickAddPending === 'true') return;
    const id = Number(button.dataset.variantId);
    if (!id) return;

    button.dataset.quickAddPending = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-added', 'has-error');
    button.textContent = 'Adding';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Unable to add product');
      const panel = button.closest('[data-quick-size-panel]');
      if (panel) {
        panel.hidden = true;
        const chooser = panel.parentElement?.querySelector('[data-quick-add-choose]');
        if (chooser) chooser.setAttribute('aria-expanded', 'false');
      }
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Unable to refresh cart');
      const cart = await cartResponse.json();
      updateCartLabels(cart.item_count || 0);
      button.classList.add('is-added');
      button.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      button.classList.add('has-error');
      button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => {
        button.innerHTML = originalMarkup;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.dataset.quickAddPending = 'false';
        button.classList.remove('is-added', 'has-error');
      }, 1600);
    }
  });
}

function updateCartLabels(itemCount) {
  document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = itemCount; });
  document.querySelectorAll('.rox-bag-button').forEach((button) => {
    button.setAttribute('aria-label', `Shopping bag with ${itemCount} items`);
  });
}

function bindGlobalQuickAdds() {
  document.querySelectorAll('[data-quick-add]').forEach(bindQuickAddButton);
  document.querySelectorAll('[data-quick-add-choose]').forEach(bindQuickAddChooser);
}

function bindQuickAddChooser(button) {
  if (button.dataset.chooseBound === 'true') return;
  button.dataset.chooseBound = 'true';
  button.addEventListener('click', (event) => {
    event.preventDefault();
    const panel = button.parentElement?.querySelector('[data-quick-size-panel]');
    if (!panel) return;
    const willOpen = panel.hidden;
    document.querySelectorAll('[data-quick-size-panel]').forEach((p) => { p.hidden = true; });
    document.querySelectorAll('[data-quick-add-choose]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    panel.hidden = !willOpen;
    button.setAttribute('aria-expanded', String(willOpen));
    if (willOpen) panel.querySelector('button:not([disabled])')?.focus();
  });
  document.addEventListener('click', (event) => {
    const panel = button.parentElement?.querySelector('[data-quick-size-panel]');
    if (panel && !panel.hidden && !button.parentElement.contains(event.target)) {
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    }
  });
}

function bindMobileMenus() {
  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    if (button.dataset.menuBound === 'true') return;
    button.dataset.menuBound = 'true';
    const nav = document.getElementById(button.getAttribute('aria-controls'));
    if (!nav) return;
    const closeButton = nav.querySelector('[data-menu-close]');
    let scrollPosition = 0;
    let lastFocusedElement = null;

    const getFocusableElements = () => [...nav.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hidden && element.getClientRects().length > 0);

    const unlockPage = () => {
      document.body.classList.remove('rox-mobile-menu-open');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('width');
    };

    const close = ({ restoreFocus = true } = {}) => {
      if (nav.hidden) return;
      nav.hidden = true;
      nav.setAttribute('aria-hidden', 'true');
      button.setAttribute('aria-expanded', 'false');
      unlockPage();
      if (restoreFocus && lastFocusedElement instanceof HTMLElement) lastFocusedElement.focus({ preventScroll: true });
      window.scrollTo(0, scrollPosition);
      window.requestAnimationFrame(() => window.scrollTo(0, scrollPosition));
    };

    const open = () => {
      if (!nav.hidden) return;
      scrollPosition = window.scrollY;
      lastFocusedElement = document.activeElement;
      document.body.classList.add('rox-mobile-menu-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
      nav.hidden = false;
      nav.setAttribute('aria-hidden', 'false');
      button.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => closeButton?.focus());
    };

    button.addEventListener('click', () => {
      if (nav.hidden) open();
      else close();
    });
    closeButton?.addEventListener('click', () => close());
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => close({ restoreFocus: false })));

    document.addEventListener('pointerdown', (event) => {
      if (!nav.hidden && !nav.contains(event.target) && !button.contains(event.target)) close();
    });

    document.addEventListener('keydown', (event) => {
      if (nav.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = getFocusableElements();
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const desktopMedia = window.matchMedia('(min-width: 901px)');
    desktopMedia.addEventListener?.('change', (event) => {
      if (event.matches) close({ restoreFocus: false });
    });
  });
}

function bindSocksDropdowns() {
  document.querySelectorAll('[data-socks-dropdown]').forEach((dropdown) => {
    if (dropdown.dataset.dropdownBound === 'true') return;
    dropdown.dataset.dropdownBound = 'true';
    const button = dropdown.querySelector('[data-socks-dropdown-toggle]');
    const panel = dropdown.querySelector('[data-socks-dropdown-panel]');
    const isMobileDropdown = dropdown.classList.contains('mobile-dropdown');
    if (!button || !panel) return;
    const open = () => {
      panel.hidden = false;
      button.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      panel.hidden = true;
      button.setAttribute('aria-expanded', 'false');
    };
    if (!isMobileDropdown) {
      dropdown.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') open();
      });
      dropdown.addEventListener('pointerleave', () => {
        if (!dropdown.contains(document.activeElement)) close();
      });
      dropdown.addEventListener('focusin', open);
      dropdown.addEventListener('focusout', (event) => {
        if (!dropdown.contains(event.relatedTarget)) close();
      });
    }
    button.addEventListener('click', (event) => {
      event.stopPropagation();
      const open = panel.hidden;
      panel.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
    });
    panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));
    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    bindGlobalQuickAdds();
    bindMobileMenus();
    bindSocksDropdowns();
  });
} else {
  bindGlobalQuickAdds();
  bindMobileMenus();
  bindSocksDropdowns();
}
